import {
    Takeout2Post,
    Takeout2Processing,
    DeviceConfig as _DeviceConfig,
    Gateway as _Gateway,
    Group as _Group,
    Ota as _Ota,
    Registry as _Registry,
} from "generated/models";
import { ActuatorCommand } from "types/Actuator";
import { MemberDto } from "./Organisation";
import { RecipientMode } from "./common";

export type MessageType = {
    subject: string;
    text: string;
};

export enum PortStatus {
    On,
    FaultyHardware,
    FaultyIndividual,
    FaultyAll,
    NoDevice,
}

export type LDSBus = {
    id: number;
    power: boolean;
    status: PortStatus;
};

export type GatewayDeviceList = {
    allRegistry: any[];
    deviceList: any[];
};

export type SensorTypeObject = {
    id: string;
    name: string;
};

/**
 * Backend response
 */
export type GatewayObj = "PCS_GW" | "NON-POE" | "LORAWAN-GW";

export type GatewayLDSUDetailsProps = {
    nameEditable: string;
    handleNameChange: (e: any) => void;
    isNameEditing: boolean;
    handleClickEdit: () => void;
    handleClickUpdate: () => Promise<void>;
    isRefreshing: boolean;
    refreshThisGateway: () => Promise<void>;
    timestampDetails: {
        heartbeat: number;
        info: boolean;
    };
    registryDetails: any;
    hasOnboard: React.SetStateAction<boolean>;
    gatewayId: string;
};

export type GatewayReading = {
    heartbeat: number;
    devices: GatewayReadingDevice[];
};

export type GatewayReadingDevice = {
    UID: string;
    ts: number;
    value: number[];
    min: number[];
    max: number[];
};

export type RecipientConfig = {
    recipients: MemberDto[];
    isEnabled: boolean;
    recipientMode: RecipientMode;
};

export type AlertConfig = Record<RecipientMode, RecipientConfig>;

export type DownloadOptions = "email" | "fast";

export type DownloadIntervalTime = Takeout2Processing;

export type DownloadPayload = Takeout2Post;

export type DeviceConfig = Omit<_DeviceConfig, "CMDS"> & {
    CMDS: ActuatorCommand[];
};

export type Group = Omit<_Group, "gateways"> & {
    gateways: Registry[];
};

export type Gateway = Omit<_Gateway, "bus_power"> & {
    bus_power: boolean[];
    registry?: _Registry;
    devices: any[];
    model: string;
    WASC: string;
    WSCS: string;
};

export type Ota = Omit<_Ota, "create_time" | "modify_time"> & {
    /* Override the Date type from the generated file */
    create_time: string;
    /* Override the Date type from the generated file */
    modify_time: string;
};

export type Registry = Omit<_Registry, "info" | "ota" | "configs"> & {
    info?: Gateway;
    ota?: Ota;
    configs: DeviceConfig[];
};
